var scope_0 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/81690e068bbfd8f788d1b2b184209d6a.js').default;export default
        Object.assign({}, scope_0 )
    